import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import cn from 'classnames'
import { FILTER_SORT } from '../../../constants'
import { pushOpenSortLowSearch, pushOpenSortHighSearch } from '../../../../../helpers/gtm'
import './sort.scss'

class Sort extends PureComponent {
  state = {
    active: null,
  }

  onChangeHandler = (...args) => {
    const { filterChangeAction, filterApplyAction } = this.props
    const value = parseInt(args[1], 10)
    this.setState({ active: value })
    filterChangeAction(FILTER_SORT, value)
    filterApplyAction(FILTER_SORT, false)
    if (value === 1) {
      pushOpenSortLowSearch()
    } else {
      pushOpenSortHighSearch()
    }
  }

  isChecked = id => this.state.active === (id + 1) || this.props.sort === (id + 1)

  radioId = id => `sort-radio-${id}`

  fieldName = id => `sort_${id}`

  render() {
    const { titles: { items } } = this.props
    return (
      <div className="sort-filter">
        <div className="filter-sort__items">
          {items && items.map((item, key) => (
            <div
              key={key}
              className={cn('filter-sort__item', this.isChecked(key) && 'checked')}
            >
              <label
                className="filter-sort__item-label"
                htmlFor={this.radioId(key)}
              >
                {item}
              </label>
              <Field
                id={this.radioId(key)}
                className="filter-sort__item-field"
                name={this.fieldName(key)}
                type="radio"
                component="input"
                onChange={this.onChangeHandler}
                value={key + 1}
                checked={this.isChecked(key)}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }
}

Sort.propTypes = {
  titles: PropTypes.shape({
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.string.isRequired),
    apply: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
  }),
  sort: PropTypes.number,
  filterChangeAction: PropTypes.func.isRequired,
  filterApplyAction: PropTypes.func.isRequired,
}

Sort.defaultProps = {
  titles: [],
  sort: 0,
}

export default Sort
